// FAQs accordion toggle
// Selector: .faqs .faqs-question — does not conflict with deprecated .accordion block

export function initFaqs(root = document) {
    root.querySelectorAll('.faqs .faqs-question:not([data-faqs-bound])').forEach(function (btn) {
        btn.dataset.faqsBound = 'true';

        btn.addEventListener('click', function () {
            var panel = document.getElementById(this.getAttribute('aria-controls'));
            var isOpen = this.getAttribute('aria-expanded') === 'true';

            this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            if (panel) {
                panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
            }
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        initFaqs();
    });
} else {
    initFaqs();
}
